import React from 'react';
import { ClinicInfoPanel } from '../../settings/clinicsettings/info/clinicInfoParts';

const WARNING_ITEMS = [
    {
        icon: 'bi-exclamation-lg',
        tone: 'danger',
        text: 'Changes will immediately impact all future outgoing communication.',
    },
    {
        icon: 'bi-x-lg',
        tone: 'danger',
        text: 'Changes cannot be reverted — there is no version history.',
    },
    {
        icon: 'bi-shield-lock',
        tone: 'primary',
        text: 'Only authorized and responsible staff should make template changes.',
    },
    {
        icon: 'bi-hourglass-split',
        tone: 'muted',
        text: 'Updates may not take effect immediately, depending on system caching.',
    },
    {
        icon: 'bi-envelope-check',
        tone: 'success',
        text: 'Changes will not affect previously sent messages or calls.',
    },
];

const Overview = () => {
    return (
        <>
            <div className="templates-notice-banner">
                <span className="templates-notice-banner__icon">
                    <i className="bi bi-exclamation-triangle"></i>
                </span>
                <div>
                    <h6 className="templates-notice-banner__title">Read before editing templates</h6>
                    <p className="templates-notice-banner__text">
                        You are about to modify communication templates used for sending{' '}
                        <strong>SMS messages, emails, and automated phone calls</strong>.
                        Proceed only if you fully understand the impact.
                    </p>
                </div>
            </div>

            <ClinicInfoPanel title="What to know" icon="bi-info-circle">
                <ul className="templates-warning-list">
                    {WARNING_ITEMS.map((item) => (
                        <li key={item.text}>
                            <span
                                className={`templates-warning-list__icon templates-warning-list__icon--${item.tone}`}
                            >
                                <i className={`bi ${item.icon}`}></i>
                            </span>
                            <span>{item.text}</span>
                        </li>
                    ))}
                </ul>
            </ClinicInfoPanel>
        </>
    );
};

export default Overview;
